import styled from 'styled-components/macro';
import { Flex } from 'common/common.styles';

export const Controls = styled.div`
  display: flex;
  padding-right: 20px;

  > * + * {
    margin-left: 10px;
  }

  > *:last-child {
    margin-left: 26px;
  }
`;

export const TitleWrapper = styled(Flex)`
  flex-direction: column;

  p {
    margin-top: 5px;
  }
`;
